import { render, staticRenderFns } from "./DepartmentProgram.vue?vue&type=template&id=d41afd68&scoped=true"
import script from "./DepartmentProgram.vue?vue&type=script&lang=js"
export * from "./DepartmentProgram.vue?vue&type=script&lang=js"
import style0 from "./DepartmentProgram.vue?vue&type=style&index=0&id=d41afd68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41afd68",
  null
  
)

export default component.exports